import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import moment from 'moment';

export const Context = createContext({});

export const Provider = ({ children }) => {
  const getDefaultValues = () => ({
    current: 0,
    opisZadatka: '',
    datumOd: moment(),
    datumDo: moment().add(2, 'weeks'),
    taskType: '',
    selectedBuyerIds: [],
    selectedProductIds: [],
  });

  const [current, setCurrent] = useState(() => {
    const savedCurrent = localStorage.getItem('current');
    return savedCurrent !== null ? +savedCurrent : getDefaultValues().current;
  });
  const [opisZadatka, setOpisZadatka] = useState(() => {
    const savedOpisZadatka = localStorage.getItem('opisZadatka');
    return savedOpisZadatka !== null
      ? savedOpisZadatka
      : getDefaultValues().opisZadatka;
  });
  const [datumOd, setDatumOd] = useState(() => {
    const savedDatumOd = localStorage.getItem('datumOd');
    return savedDatumOd !== null
      ? moment(savedDatumOd)
      : getDefaultValues().datumOd;
  });
  const [datumDo, setDatumDo] = useState(() => {
    const savedDatumDo = localStorage.getItem('datumDo');
    return savedDatumDo !== null
      ? moment(savedDatumDo)
      : getDefaultValues().datumDo;
  });
  const [taskType, setTaskType] = useState(() => {
    const savedTaskType = localStorage.getItem('taskType');
    return savedTaskType !== null ? savedTaskType : getDefaultValues().taskType;
  });

  const [selectedBuyerIds, setSelectedBuyerIds] = useState(() => {
    const savedSelectedBuyerIds = localStorage.getItem('selectedBuyerIds');
    return savedSelectedBuyerIds !== null
      ? JSON.parse(savedSelectedBuyerIds)
      : getDefaultValues().selectedBuyerIds;
  });

  const [selectedProductIds, setSelectedProductIds] = useState(() => {
    const savedSelectedProductIds = localStorage.getItem('selectedProductIds');
    return savedSelectedProductIds !== null
      ? JSON.parse(savedSelectedProductIds)
      : getDefaultValues().selectedProductIds;
  });

  const clearLocalStorage = useCallback(() => {
    localStorage.setItem('current', '1');
    localStorage.removeItem('opisZadatka');
    localStorage.removeItem('datumOd');
    localStorage.removeItem('datumDo');
    localStorage.removeItem('taskType');
    localStorage.removeItem('selectedProductIds');
    const defaultValues = getDefaultValues();
    setCurrent(1);
    setOpisZadatka(defaultValues.opisZadatka);
    setDatumOd(defaultValues.datumOd);
    setDatumDo(defaultValues.datumDo);
    setTaskType(defaultValues.taskType);
    setSelectedProductIds(defaultValues.selectedProductIds);
  }, []);

  const clearBuyers = useCallback(() => {
    localStorage.removeItem('selectedBuyerIds');
    localStorage.removeItem('current');
    const defaultValues = getDefaultValues();
    setSelectedBuyerIds(defaultValues.selectedBuyerIds);
    setCurrent(defaultValues.current);
  }, []);

  const createtaskContext = useMemo(
    () => ({
      current,
      setCurrent,
      opisZadatka,
      setOpisZadatka,
      datumOd,
      setDatumOd,
      datumDo,
      setDatumDo,
      clearLocalStorage,
      taskType,
      setTaskType,
      selectedBuyerIds,
      setSelectedBuyerIds,
      selectedProductIds,
      setSelectedProductIds,
      clearBuyers,
    }),
    [
      current,
      opisZadatka,
      datumOd,
      datumDo,
      taskType,
      selectedBuyerIds,
      selectedProductIds,
      clearLocalStorage,
      clearBuyers,
    ],
  );

  return (
    <Context.Provider value={createtaskContext}>{children}</Context.Provider>
  );
};

export const { Consumer } = Context;

export const useCreateTaskContext = () => useContext(Context);
